/* eslint-disable import/prefer-default-export */
import React from "react";
import DateException from "./modules/DateException.jsx";
import DisasterRecovery from "./modules/DisasterRecovery.jsx";
import MidCallTransfer from "./modules/MidCallTransfer.jsx";
import MissedCallAlert from "./modules/MissedCallAlert.jsx";
import CallRecording from "./modules/CallRecording.jsx";
import PreConnectionGreeting from "./modules/PreConnectionGreeting.jsx";
import WhisperAnnouncement from "./modules/WhisperAnnouncement.jsx";
import CliPresentation from "./modules/CliPresentation.jsx";
import VoicemailModule from "./modules/VoicemailModule.jsx";
import OutOfHours from "./modules/OutOfHours.jsx";
import Queue from "./modules/Queue.jsx";
import CallerException from "./modules/CallerException.jsx";
import SummaryItem from "./components/SummaryItem.jsx";
import SectionItem from "./components/SectionItem.jsx";
import Callshield from "./modules/Callshield.jsx";

export const displayModuleType = {
  PRE_CONNECTION(module) {
    return <PreConnectionGreeting module={module} key={`PC_${module.name}`} />;
  },
  DATE_EXCEPTION(module) {
    return <DateException module={module} key={`DE_${module.name}`} />;
  },
  CALLER_EXCEPTION(module) {
    return <CallerException module={module} key={`CE_${module.name}`} />;
  },
  CALL_RECORDING(module) {
    return <CallRecording module={module} key={"CR_"} />;
  },
  MIDCALL(module) {
    return <MidCallTransfer module={module} key={"MCT_"} />;
  },
  WHISPER(module) {
    return <WhisperAnnouncement module={module} key={"WA_"} />;
  },
  CLI_PRESENTATION(module) {
    return <CliPresentation module={module} key={"CP_"} />;
  },
  VOICEMAIL(module) {
    return <VoicemailModule module={module} key={"VM_"} />;
  },
  MISSED_CALL_ALERT(module) {
    return <MissedCallAlert module={module} key={"MCA_"} />;
  },
  QUEUE(module) {
    return <Queue module={module} key={"Q"} />;
  },
  OUT_OF_HOURS(module, sites, clientId) {
    return (
      <OutOfHours
        module={module}
        sites={sites}
        clientId={clientId}
        key={"OOH_"}
      />
    );
  },
  DISASTER_RECOVERY(module) {
    if (module.disasterRecoveryGroup)
      return <DisasterRecovery module={module} key={`DR_${module.name}`} />;
    return <span key="null_span" />;
  },
  SERVICE_CUSTOMTIMEZONE(module) {
    return (
      <SummaryItem itemKey="TimeZone:">
        <SectionItem itemKey={module.timeZoneId} />
      </SummaryItem>
    );
  },
  CALLSHIELD_EXCEPTION(module) {
    return <Callshield module={module} />;
  },
};
